'use strict';//Indicating browser should run only in java script mode
; (function () {
    angular.module('EMR.SelectUsersToViewTasksModule', []);

    var selectUsersToViewTasksModuleRoutes = [

        {
            "name": "SelectUsersToViewTasksPopup",
            "url": "/SelectUsersToViewTasksPopup",
            "templateUrl": "AngularScripts/SelectUsersToViewTasks/Htmls/SelectUsersToViewTasksPopup.html",
            "directivescontrollersFiles": "920001",
            "RoutingNumber": 4567,
            files: [
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/SelectUsersToViewTasks/Services/SelectUsersToViewTasksService.js",
                "AngularScripts/SelectUsersToViewTasks/Controllers/SelectUsersToViewTasksPopupController.js",
                
            ]
        },
        
    ];


    angular.module('EMR.SelectUsersToViewTasksModule')
    .constant("selectUsersToViewTasksModuleRoutes", selectUsersToViewTasksModuleRoutes)
    .config(["$stateProvider", "EmrRouteProvider", "selectUsersToViewTasksModuleRoutes",
        function ($stateProvider, EmrRouteProvider, selectUsersToViewTasksModuleRoutes) {
            debugger;
            EmrRouteProvider.registerStates(selectUsersToViewTasksModuleRoutes, $stateProvider);
        }]);
})();
